import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  permission?: string;
}

export function ProtectedRoute({ children, permission }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  // Mostra loading enquanto verifica autenticacao
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600"></div>
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  // Redireciona para login se nao autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verifica permissao se especificada
  if (permission && !hasPermission(permission)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-error">Acesso Negado</h1>
          <p className="mt-4 text-muted-foreground">
            Voce nao tem permissao para acessar esta pagina.
          </p>
          <a
            href="/dashboard"
            className="mt-6 inline-block text-primary-600 hover:underline"
          >
            Voltar para o Dashboard
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
